import React from 'react'
import { get } from 'lodash'

import { generateAddress } from '../helpers/clinic'

export default ({globalData, doctors, clinic, callback, cta}) => {
  return (
    <div
      className={`bg-white py-4 md:py-8 px-4 text-center rounded-xl flex-1 overflow-hidden`}
      onClick={() => { callback(clinic) }}
    >
      <h2 className="text-base md:text-xl font-bold mb-1 text-sky-500">{clinic.name}</h2>
      <div className="text-xs mb-4 md:mb-8">
        { generateAddress(clinic) }
      </div>
      {
        doctors?.length &&
        <div className="flex-1 mb-2 md:mb-4 flex gap-2 mx-auto max-w-[280px]">
          {
            doctors.map((d, ndx) => {
              return <div className="rounded-full overflow-hidden" key={`${clinic.name}-doctor-${ndx}`}>
                <img src={d.image?.url} alt={d.name}></img>
               </div>
            })
          }
        </div>
      }
      {
        doctors?.length &&
        <div className="text-xs mb-4 md:mb-8 mx-auto max-w-[200px] text-left">
          {
            doctors.map((d, ndx) => {
              return <div className="block mb-1" key={`appt-${clinic.url}-doctor-${ndx}`}>
                
                {d.name}
              
              </div>
            })
          }
        </div>
      }
      {
        clinic.bulletinSmall !== null &&
        <div className="text-sm mb-4 ecs-html text-sky-500" dangerouslySetInnerHTML={{__html: clinic.bulletinSmall.html}}>
        </div>
      }
      {
        callback !== undefined && cta !== undefined &&
        <div className="text-sm md:text-base font-bold whitespace-nowrap hover:underline select-none cursor-pointer">
          {cta} <span className="material-symbols-rounded text-xs">arrow_forward_ios</span>
        </div>
      }
    </div>
  )
}